import { NgModule, Injectable, Injector } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class NgMixModule {
}
NgMixModule.ɵfac = function NgMixModule_Factory(t) { return new (t || NgMixModule)(); };
NgMixModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgMixModule });
NgMixModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgMixModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: []
            }]
    }], null, null); })();

class BaseClassInjector {
    constructor(injector) {
        this.injector = injector;
    }
    ngOnChanges(changes) { }
    ngOnInit() { }
    ngDoCheck() { }
    ngAfterContentInit() { }
    ngAfterContentChecked() { }
    ngAfterViewInit() { }
    ngAfterViewChecked() { }
    ngOnDestroy() { }
}
BaseClassInjector.ɵfac = function BaseClassInjector_Factory(t) { return new (t || BaseClassInjector)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
BaseClassInjector.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BaseClassInjector, factory: BaseClassInjector.ɵfac });
BaseClassInjector.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseClassInjector, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
class Base extends BaseClassInjector {
}
;

/**
 * @deprecated The method should not be used
 */
const composeMixins = (...functions) => functions.reduce((a, b) => (...args) => a(b(...args)))();

/*
 * Public API Surface of ng-mix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Base, BaseClassInjector, NgMixModule, composeMixins };

//# sourceMappingURL=ng-mix.js.map